import { useContext } from 'react';

import { RootWidthContext } from '../rootWidth';

/**
 * Определить, что приложение встроено в сторонний сервис как виджет.
 *
 * @returns Флаг, указывающий, находится ли приложение внутри контейнера.
 */
export const useIsInsideContainer = () => {
  const rootWidth = useContext(RootWidthContext);

  return typeof rootWidth === 'number';
};
